import { isValid } from "../../utils/utilitiesmodule";
import "../../utils/messages";
import { REGIONS_NOT_RETRIEVED, REPOSITORY_MESSAGES } from "../../utils/messages";
import { ClientMessage } from "../../utils/objects";

export function assignRepositoryRequests(api) {
    /**********************************************REPOSITORIES*****************************************************************/

    //export const repositoryAPI = {
    api.getRepositories = async function () {
        var response = await api.get('/enterprise/repositories', this.buildConfig())
            .then(res => res.data.map(x => {
                if (!isValid(x.type_name) || x.type_name.toLowerCase() == "unknown")
                    x.type_name = this.$ONEServiceTypeInfo[x.type].name;
                return x;
            }))
            .catch(e => {
                this.checkError(e, REPOSITORY_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }

    api.createRepository = async function (repository) {
        var clientMessage = ClientMessage.success(REPOSITORY_MESSAGES.CREATED, { 0: repository.name }, "repository");

        var response = await api.post('/enterprise/repositories', repository, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                clientMessage = this.checkError(e, REPOSITORY_MESSAGES.NOT_CREATED, { 0: repository.name });
                return null;
            });
        this.emitFunction("sendClientMessage", clientMessage, "repository");

        return response;
    }

    api.editRepository = async function (repository) {
        var clientMessage = ClientMessage.success(REPOSITORY_MESSAGES.MODIFIED, { 0: repository.name }, "repository");

        var response = await api.put('/enterprise/repositories', repository, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                clientMessage = this.checkError(e, REPOSITORY_MESSAGES.NOT_MODIFIED, { 0: repository.name });
                return null;
            });
        this.emitFunction("sendClientMessage", clientMessage, "repository");


        return response;
    }

    api.deleteRepository = async function (repoID, repoName) {
        var clientMessage = ClientMessage.success(REPOSITORY_MESSAGES.DELETED, { 0: repoName }, "repository");

        var response = await api.delete('/enterprise/repositories/' + repoID, this.buildConfig())
            .then(() => true)
            .catch(e => {
                if (e.status == 404)
                    return true;
                console.writeError(e);
                clientMessage = this.checkError(e, REPOSITORY_MESSAGES.NOT_DELETED, { 0: repoName });
                return false;
            });

        this.emitFunction("sendClientMessage", clientMessage, "repository");


        return response;
    }

    api.getAmazonRegions = async function () {
        var response = await api.get('/enterprise/awsregions', this.buildConfig())
            .then(response => {
                var regions = response.data.filter(region => region.ForType == undefined);

                return regions;
            })
            .catch(e => {
                this.checkError(e, REGIONS_NOT_RETRIEVED);
                return null;
            });

        return response;
    }

    api.getExchangeRegions = async function () {
        var response = await api.get('/enterprise/awsregions', this.buildConfig())
            .then(response => {
                var regions = response.data.filter(region => isValid(region.ForType));

                return regions;
            })
            .catch(e => {
                this.checkError(e, REGIONS_NOT_RETRIEVED);
                return null;
            });

        return response;
    }
    //}
}
